import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'

const SPINNER_FRAMES = ['/', '—', '\\', '|']

export const Loader: FunctionalComponent = () => {
  const [frame, setFrame] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setFrame((prev) => (prev + 1) % SPINNER_FRAMES.length)
    }, 200)

    return () => clearInterval(timer)
  }, [])

  return (
    <>
      {SPINNER_FRAMES[frame]}
    </>
  )
}
